import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Alert from "react-bootstrap/Alert";
import Select from 'react-select';
import AppButton from "../layout/AppButton";
import { useUserAdmin } from "../../hooks/useUserAdmin";
import { usePersonaAdmin } from "../../hooks/usePersonaAdmin";
import { useRoleAdmin } from "../../hooks/useRoleAdmin";

const UserRegistration = () => {
    const { registerUser } = useUserAdmin();
    const { fetchPersonaUserGroups } = usePersonaAdmin();
    const { fetchRoles } = useRoleAdmin();

    const [validated, setValidated] = useState(false);
    const [userType, setuserType] = useState("Member");
    const [EmailAdress, setEmail] = useState("");
    const [isLoading, setIsloading] = useState(false);
    const [issuccess, setsuccess] = useState(false);
    const [iserror, seterror] = useState(false);
    const [iserrorEmail, setiserrorEmail] = useState(false);

    useEffect(() => {
      document.title = "User Registration";
    });
  
    var SelectedList = ["aaysinsight.com"];

    const emailid  = localStorage.getItem("myemail");
    const handleSubmit = (event) => {
      event.preventDefault();
      const form = event.currentTarget;
      var splitArray = EmailAdress.split('@');

      // console.log(form);
      if (form.checkValidity() === false) {
        event.preventDefault();
        event.stopPropagation();
      } 
      else {
       
        if(SelectedList.indexOf(splitArray[1]) >= 0){
          setValidated(true);
          setIsloading(true);
  
          const data = {
            emailAddress: EmailAdress.toLowerCase(),
            userType: userType,
            userGroup:selectedPersona1,
            rlType:selectedOptionsDataRl,
            assignUser:emailid
          }

          registerUser(data)
            .then(function () {
                setIsloading(false)
                setValidated(false)
                setuserType("Member")
                setEmail("")
                setsuccess(true)
                setTimeout(() => {
                  setsuccess(false);
                }, 10000);
                seterror(false);
            })
            .catch(function (error) {
              // console.log(error);
              setIsloading(false);
              setValidated(false);
              setsuccess(false);
              seterror(true);
              setTimeout(() => {
                seterror(false);
              }, 10000);
            });
        }
        else{
          setiserrorEmail(true)
          setTimeout(() => {
            setiserrorEmail(false)
          }, 5000);

        }
       
      }
      setValidated(true);
    };

   
  
   
    const resetForm = (e) => {
      e.preventDefault();
      setValidated(false)
      setuserType("Member")
      setEmail("")
      setSelectedOptions([])
      setselectedOptionsPersona([])
    };

   

    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedOptionsDataRl, setselectedOptionsDataRl] = useState([]);

    const [selectedOptionsPersona, setselectedOptionsPersona] = useState([]);
    const [selectedPersona1, setselectedPersona1] = useState([]);

    const [userGroupMap, setUserGroupMap] = useState({});
    const [roleOptions, setRoleOptions] = useState([]);

    const personaOptions = Object.entries(userGroupMap).map(([id, name]) => ({
        value: Number(id),
        label: name,
    }));

    useEffect(() => {
        const fetchUserGroups = async () => {
            try {
                const data = await fetchPersonaUserGroups();
                const map = {};
                data.forEach((g) => { map[g.id] = g.name; });
                setUserGroupMap(map);
            } catch (err) {}
        };
        fetchUserGroups();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const fetchRoleOptions = async () => {
            try {
                const data = await fetchRoles();
                setRoleOptions(
                    data.map((r) => ({ value: r.roleName, label: r.roleName }))
                );
            } catch (err) {}
        };
        fetchRoleOptions();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const handleChange = (selectedOptions) => {
      const selectedValues = selectedOptions.map((option) => option.value);
      setSelectedOptions(selectedOptions)
      const userGroupsArrayRLtype = selectedValues.map((value) => ({ "RLtypename": value }));

      setselectedOptionsDataRl(userGroupsArrayRLtype);

    };

    const handleChangePersona = (selectedOptions) => {
      const selectedValues = selectedOptions.map((option) => option.value);
      setselectedOptionsPersona(selectedOptions)
      const userGroupsArray = selectedValues.map((value) => ({ "userGroupId": value }));

      setselectedPersona1(userGroupsArray);
    };
  

    const canSubmit =
      EmailAdress.trim().length > 0 &&
      !!userType &&
      selectedOptionsPersona.length > 0;
    
  return (
    <div id="userRegId">
       
      <div>
    
          <div id="Create_users_id">
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Row className="mb-3">
                <Form.Group as={Col} md="4" controlId="validationCustom01Email">
                  <Form.Label>Email *</Form.Label>
                  <Form.Control
                    className="validationCustom01Email"
                    autoComplete="off"
                    required
                    type="email"
                    placeholder="Email Address"
                    value={EmailAdress}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <Form.Control.Feedback type="invalid">
                    Email Address is required *
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group as={Col} md="4" controlId="validationCustom02">
                  <Form.Label>User Type *</Form.Label>

                  <Form.Select
                    required
                    value={userType}
                    onChange={(e) => setuserType(e.target.value)}
                  >
                    <option value="Member">Member</option>
                    <option value="Admin">Admin</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    User Type is required *
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group as={Col} md="4" controlId="validationCustom03Pesona">
                  <Form.Label>Group Type *</Form.Label>

                  <Select
                    options={personaOptions}
                    required
                    isMulti
                    placeholder="Select Group Types"
                    value={selectedOptionsPersona}
                    onChange={handleChangePersona}
                    className="RlTypesCls"
                  />
                  <Form.Control.Feedback type="invalid">
                    Group Type is required *
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>

              <Row className="mb-3">
             
              <Form.Group as={Col} md="4" controlId="validationCustom04RLType">
              <Form.Label>Roles (If report has RLS)</Form.Label>

              <Select
                options={roleOptions}
                isMulti
                placeholder="Select Roles"
                value={selectedOptions}
                onChange={handleChange}
                className="RlTypesCls"
              />
              
              </Form.Group>

               
              
              </Row>

              <div
                style={{ gridGap: "10px", display: "flex", marginTop: "2rem", justifyContent: "flex-end" }}
                className="mb-3"
              >
               
                <AppButton onClick={resetForm} variant="secondary" type="reset" disabled={isLoading}>
                  Reset
                </AppButton>

                <AppButton disabled={isLoading || !canSubmit} variant="fill" type="submit">
                  
                  {isLoading 
                ? 
                <>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span style={{paddingLeft:"10px"}}>Adding...</span>
              </> 

                : "Register User"}
                </AppButton>
              </div>
            </Form>
          </div>
        

        {issuccess && (
          <div>
            <Alert
              style={{ position: "absolute", right: "20px", top: "10px" }}
              variant="success"
            >
              <p className="mb-0">User Successfully Registered</p>
            </Alert>
          </div>
        )}

        {iserror && (
          <div>
            <Alert
              style={{ position: "absolute", right: "20px", top: "10px" }}
              variant="danger"
            >
              <p className="mb-0">
                  User already exists
              </p>
            </Alert>
          </div>
        )}

        {iserrorEmail && (
          <div>
            <Alert
              style={{ position: "absolute", right: "20px", top: "10px" }}
              variant="danger"
            >
              <p className="mb-0">
                Please use '@aaysinsight.com' email id 

              </p>
            </Alert>
          </div>
        )}
      </div>
    </div>
  );
}

export default UserRegistration
